import createHashHistory from 'history/lib/createHashHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createHashHistory);


//////////////////
// WEBPACK FOOTER
// ./~/react-router/es/hashHistory.js
// module id = 676
// module chunks = 0